import { gsap, Elastic, Bounce } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

document.addEventListener('DOMContentLoaded',function() {
    gsap.registerPlugin(ScrollTrigger);
    
    window.anims = function() {   
        
        gsap.utils.toArray(".js-fadeInChildren > *").forEach(function(section) {
            gsap.from(section, {
                scrollTrigger: {
                    trigger: section,
                    start: '-50px bottom',
                    toggleActions: "play complete complete reset",
                },
                opacity: 0, 
                duration: 1,
                y: 50
            });
        });
        
/*
        gsap.from(".c-hero", {
            ease: "none",
            scrollTrigger: {
                trigger: ".c-hero",
                onLeave: ()=> {
                   typewriter.stop();
                },
                onEnterBack: ()=> {
                   typewriter.start();
                },
            }, 
        });      
*/  
        
        gsap.from(".c-cards .o-planet", {
            yPercent: 20,
            ease: "none",
            scrollTrigger: {
                trigger: ".c-cards .o-planet",
                scrub: 1,
                start: 'top bottom',
            }, 
        });
        
        gsap.from(".c-findplace .o-lens", {
            xPercent: 20,
            ease: "none",
            scrollTrigger: {
                trigger: ".c-findplace .o-lens",
                scrub: 1,
                start: 'top bottom',
            }, 
        });
        
/*
        gsap.set(".c-about picture", {
            yPercent: -50,
        })
*/

        gsap.to(".c-about picture", {
            yPercent: -15,
            ease: "none",
            scrollTrigger: {
                trigger: ".c-about picture",
                scrub: 1,
                start: 'top bottom',
            }, 
        });
        
        gsap.set(".c-recruitment picture", {
            yPercent: -20,
        })

        gsap.to(".c-recruitment picture", {
            yPercent: 0,
            ease: "none",
            scrollTrigger: {
                trigger: ".c-recruitment picture",
                scrub: 1,
                start: 'top bottom',
            }, 
        });

        if (document.querySelector('.js-cards')) {
             gsap.from('.js-cards', {
                scrollTrigger: {
                    trigger: '.js-cards',
                    scrub: 2.2,
                    start: 'top bottom',
                    end: 'top center'
                },      
                xPercent: 15
            });
            
            gsap.from('.c-work .js-dots', {
                scrollTrigger: { trigger: '.c-work', scrub: 1 }, y: -200
            });
        }
    };
    
    
/*
    window.addEventListener('load', function() {
       // console.clear();
       // console.log('refresh');
        
        setTimeout(function() {
            ScrollTrigger.refresh();            
        }, 2000)
    })
*/

}, false)
